import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
 
@Component({
  selector: 'app-modals-observation',
  templateUrl: './modals-observation.component.html',
  styleUrls: ['./modals-observation.component.css']
})
export class ModalsObservationComponent  {
  observations: any;
  constructor(@Inject(MAT_DIALOG_DATA)
    public data: any) {
  }
  
}